/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import classnames from 'classnames';

import { useDefaultStyles } from './use-default-styles';
import { getShortHeadlineStyles } from './styles/short-headline';
import { getLongHeadlineStyles } from './styles/long-headline';
import { getDescriptionStyles } from './styles/description';
import { getFinalUrlStyles } from './styles/final-url';
import { AdsLabel } from './ads-label';

type TextContainerProps = {
  className: string,
  text: string,
  // eslint-disable-next-line react/no-unused-prop-types
  showMultiline?: boolean,
};

const TextContainer = React.forwardRef<HTMLDivElement, TextContainerProps>(({
  className,
  text,
}, ref) => (
  <div
    className={className}
    dangerouslySetInnerHTML={{
      __html: text.replaceAll('\uE000', '<strong>').replaceAll('\uE001', '</strong>'),
    }}
  />
));

export type ShortHeadlineProps = {
  styleOverrides: object,
  showShortHeadlineMultiline?: boolean,
  shortHeadline: string,
};

export const ShortHeadline = React.forwardRef<HTMLDivElement, ShortHeadlineProps>(({
  styleOverrides,
  showShortHeadlineMultiline,
  shortHeadline,
}, ref) => {
  const classes = useDefaultStyles(getShortHeadlineStyles({ styleOverrides })) as any;

  return (
    <TextContainer
      ref={ref}
      showMultiline={showShortHeadlineMultiline}
      className={classnames('short-headline', classes.shortHeadline)}
      text={shortHeadline}
    />
  );
});

export type LongHeadlineProps = {
  styleOverrides: object,
  showMultipleLineLongHeadline?: boolean,
  longHeadline: string,
};

export const LongHeadline = React.forwardRef<HTMLDivElement, LongHeadlineProps>(({
  styleOverrides,
  showMultipleLineLongHeadline,
  longHeadline,
}, ref) => {
  const classes = useDefaultStyles(getLongHeadlineStyles({ styleOverrides })) as any;

  return (
    <TextContainer
      ref={ref}
      showMultiline={showMultipleLineLongHeadline}
      className={classnames('long-headline', classes.longHeadline)}
      text={longHeadline}
    />
  );
});

export type DescriptionProps = {
  styleOverrides: object,
  showMultipleDescription?: boolean,
  description: string,
  showAdsLabel?: boolean,
  adsLabelText: string,
};

export const Description = React.forwardRef<HTMLDivElement, DescriptionProps>(({
  styleOverrides,
  showMultipleDescription,
  description,
  showAdsLabel,
  adsLabelText,
}, ref) => {
  const classes = useDefaultStyles(getDescriptionStyles({ styleOverrides })) as any;

  return (
    <div className={classnames('description-parent', classes.descriptionParent)}>
      {
        showAdsLabel
        && (
        <AdsLabel
          adsLabelText={adsLabelText}
          styleOverrides={styleOverrides}
        />
        )
      }
      <TextContainer
        ref={ref}
        showMultiline={showMultipleDescription}
        className={classnames('description', classes.description)}
        text={description}
      />
    </div>
  );
});

export type FinalUrlProps = {
  styleOverrides: object,
  showUrlMultiline?: boolean,
  finalUrl: string,
  displayUrl: string,
};

export const FinalUrl = React.forwardRef<HTMLDivElement, FinalUrlProps>(({
  styleOverrides,
  showUrlMultiline,
  finalUrl,
  displayUrl,
}, ref) => {
  const classes = useDefaultStyles(getFinalUrlStyles({ styleOverrides })) as any;

  return (
    <TextContainer
      ref={ref}
      showMultiline={showUrlMultiline}
      className={classnames('final-url', classes.finalUrl)}
      text={displayUrl || finalUrl}
    />
  );
});
